import "./index.css";
import LandingPageRoute from "@/routes/mockups.landing-page/route";

export function App() {
	return <LandingPageRoute />;
}

export default App;
